module.exports = __webpack_public_path__ + "a6a5b9c2abf3048807ef823517c362b8.png";